import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { PercentageIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/configuration-management/charges/$categoryId/slabs')({
  loader: () => {
    return {
      crumb: <CrumbTitle id="configurationManagement.charges.crumb.categorySlab" icon={PercentageIcon} />,
      title: <CrumbTitle id="configurationManagement.charges.crumb.categorySlab.title" />,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
